import "./App.css";
import React from "react";
import BodyFrame from "./components/layout/BodyFrame";
import FooterBar from "./components/layout/FooterBar";
import PageContentFrame from "./components/layout/PageContentFrame";
import NavBar from "./components/layout/NavBar";
import ContactPage from "./components/pages/ContactPage";
import EduIntervalQuizPage from "./components/pages/EduIntervalQuizPage/IntervalQuizPage";
import EduPage from "./components/pages/EduPage";
import HomePage from "./components/pages/HomePage";
import MusicCoversPage from "./components/pages/MusicCoversPage";
import MusicLivePage from "./components/pages/MusicLivePage";
import MusicOriginalsPage from "./components/pages/MusicOriginalsPage";
import MusicPage from "./components/pages/MusicPage";
import {
  LinkToContactPage,
  LinkToEduIntervalNotesQuizPage,
  LinkToEduPage,
  LinkToHomePage,
  LinkToMusicCoversPage,
  LinkToMusicLivePage,
  LinkToMusicOriginalsPage,
  LinkToMusicPage,
  LinkToTipJarPage,
} from "./constants/navUrlConstants";
import TipJarPage from "./components/pages/TipJarPage";

interface Props {}
interface State {
  routeHash: string;
}
export default class App extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      routeHash: window.location.hash,
    };
  }

  renderPage = () => {
    const { routeHash: route } = this.state;
    if (route === LinkToHomePage) return <HomePage />;
    else if (route === LinkToContactPage) return <ContactPage />;
    // else if (route?.startsWith(LinkToMusicPage)) return <MusicPage />;
    // else if (route === LinkToMusicLivePage) return <MusicLivePage />;
    // else if (route === LinkToMusicCoversPage) return <MusicCoversPage />;
    // else if (route === LinkToMusicOriginalsPage) return <MusicOriginalsPage />;
    else if (route === LinkToEduPage) return <EduPage />;
    else if (route === LinkToEduIntervalNotesQuizPage) return <EduIntervalQuizPage />;
    else if (route === LinkToTipJarPage) return <TipJarPage />;
    else return <HomePage />;
  };

  updateHash = () => {
    this.setState({
      routeHash: window.location.hash,
    });
  };

  componentDidMount() {
    window.addEventListener("hashchange", this.updateHash, false);
  }

  componentWillUnmount() {
    window.removeEventListener("hashchange", this.updateHash, false);
  }

  render() {
    return (
      <BodyFrame>
        <NavBar />
        <PageContentFrame>{this.renderPage()}</PageContentFrame>
        <FooterBar />
      </BodyFrame>
    );
  }
}
